/**
 * 消息收藏（v3.13）：仅存本机 localStorage。
 * 收藏一条聊天消息（文本/图片/视频/音频/文件），在「我的」页查看并跳回会话。
 */

export interface FavoriteItem {
  /** 唯一 key：`{convId}:{msgId}` */
  key: string;
  ts: number;
  /** 来源会话：peerId 或 groupId */
  convId: string;
  convKind: 'peer' | 'group';
  kind: MessageKind;
  summary: string;
  msgId: string;
  senderName?: string;
}

type MessageKind = string;

const STORE_KEY = 'mesh.favorites.v1';

export function loadFavorites(): FavoriteItem[] {
  try {
    const raw = window.localStorage.getItem(STORE_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw) as FavoriteItem[];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

/** 新增收藏（同一消息去重，最新在前）。返回更新后的完整列表。 */
export function saveFavorite(item: FavoriteItem): FavoriteItem[] {
  const list = loadFavorites().filter((f) => f.key !== item.key);
  const next = [item, ...list].slice(0, 200);
  try {
    window.localStorage.setItem(STORE_KEY, JSON.stringify(next));
  } catch {
    /* 存储满忽略 */
  }
  return next;
}

/** 取消收藏。返回更新后的完整列表。 */
export function removeFavorite(key: string): FavoriteItem[] {
  const next = loadFavorites().filter((f) => f.key !== key);
  try {
    window.localStorage.setItem(STORE_KEY, JSON.stringify(next));
  } catch {
    /* 忽略 */
  }
  return next;
}
